import { render, staticRenderFns } from "./recommend-list.mpx?vue&type=template&id=ff7cfbc0&scoped=true&component=true&componentId=recommend-list118fbdbd"
import script from "./recommend-list.mpx?vue&type=script&lang=js&component=true&componentId=recommend-list118fbdbd"
export * from "./recommend-list.mpx?vue&type=script&lang=js&component=true&componentId=recommend-list118fbdbd"
import style0 from "./recommend-list.mpx?vue&type=style&index=0&id=ff7cfbc0&lang=stylus&scoped=true&mpxStyleOptions=%7B%22mid%22%3A%22m118fbdbd%22%7D&component=true&componentId=recommend-list118fbdbd"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff7cfbc0",
  null
  
)

export default component.exports